module.exports = __webpack_public_path__ + "img/1534661372.96846733.jpg";